import { render, staticRenderFns } from "./FinancesIcon.vue?vue&type=template&id=3d3a2a00"
import script from "./FinancesIcon.vue?vue&type=script&lang=ts"
export * from "./FinancesIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports